import type { AudioDockAdapterInput, AudioDockModel } from "@/components/OmniCine/Docks/audio/audioDock.types";
import { selectAudioDockIdentity } from "@/components/OmniCine/Docks/audio/audioDock.selectors";

export function buildAudioDockModel(input: AudioDockAdapterInput): AudioDockModel {
  const identity = selectAudioDockIdentity(input);

  return {
    title: identity.title,
    subtitle: identity.subtitle,
    kindChip: identity.kindChip,
    sourceChip: identity.sourceChip,
    previewLabel: identity.previewLabel,
    featureProps: {
      previewStatus: input.previewStatus,
      previewUrl: input.previewUrl ?? identity.resolvedPreviewUrl,
      err: input.err,
      mediaCurrentTimeSec: input.mediaCurrentTimeSec,
      mediaDurationSec: input.mediaDurationSec,
      audioProgressPct: input.audioProgressPct,
      waveformBars: input.waveformBars,
      waveMotionPhase: input.waveMotionPhase,
      mediaIsPlaying: input.mediaIsPlaying,
      stageHeight: input.stageHeight,
      previewAudioRef: input.previewAudioRef,
      fmtTime: input.fmtTime,
      syncActiveMediaState: input.syncActiveMediaState,
    },
  };
}